export const selfClientSelector = (state) => state.clients.clients;
